"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KendoIntl = exports.defaultLocaleId = exports.loadLocaleData = void 0;
const KendoReactIntl = __importStar(require("@progress/kendo-react-intl"));
const TelerikIntl = __importStar(require("@telerik/kendo-intl"));
const auCalendar = __importStar(require("./data/cldr-dates-full/main/en-AU/ca-gregorian.json"));
const auCurrency = __importStar(require("./data/cldr-numbers-full/main/en-AU/currencies.json"));
const auDateFields = __importStar(require("./data/cldr-dates-full/main/en-AU/dateFields.json"));
const auNumbers = __importStar(require("./data/cldr-numbers-full/main/en-AU/numbers.json"));
const currencyData = __importStar(require("./data/cldr-core/supplemental/currencyData.json"));
const esCalendar = __importStar(require("./data/cldr-dates-full/main/es-MX/ca-gregorian.json"));
const esCurrency = __importStar(require("./data/cldr-numbers-full/main/es-MX/currencies.json"));
const esDateFields = __importStar(require("./data/cldr-dates-full/main/es-MX/dateFields.json"));
const esNumbers = __importStar(require("./data/cldr-numbers-full/main/es-MX/numbers.json"));
const frCalendar = __importStar(require("./data/cldr-dates-full/main/fr/ca-gregorian.json"));
const frCurrency = __importStar(require("./data/cldr-numbers-full/main/fr/currencies.json"));
const frDateFields = __importStar(require("./data/cldr-dates-full/main/fr/dateFields.json"));
const frNumbers = __importStar(require("./data/cldr-numbers-full/main/fr/numbers.json"));
const gbCalendar = __importStar(require("./data/cldr-dates-full/main/en-GB/ca-gregorian.json"));
const gbCurrency = __importStar(require("./data/cldr-numbers-full/main/en-GB/currencies.json"));
const gbDateFields = __importStar(require("./data/cldr-dates-full/main/en-GB/dateFields.json"));
const gbNumbers = __importStar(require("./data/cldr-numbers-full/main/en-GB/numbers.json"));
const jpCalendar = __importStar(require("./data/cldr-dates-full/main/ja/ca-gregorian.json"));
const jpCurrency = __importStar(require("./data/cldr-numbers-full/main/ja/currencies.json"));
const jpDateFields = __importStar(require("./data/cldr-dates-full/main/ja/dateFields.json"));
const jpNumbers = __importStar(require("./data/cldr-numbers-full/main/ja/numbers.json"));
const likelySubtags = __importStar(require("./data/cldr-core/supplemental/likelySubtags.json"));
const nzCalendar = __importStar(require("./data/cldr-dates-full/main/en-NZ/ca-gregorian.json"));
const nzCurrency = __importStar(require("./data/cldr-numbers-full/main/en-NZ/currencies.json"));
const nzDateFields = __importStar(require("./data/cldr-dates-full/main/en-NZ/dateFields.json"));
const nzNumbers = __importStar(require("./data/cldr-numbers-full/main/en-NZ/numbers.json"));
const qtCalendar = __importStar(require("./data/cldr-dates-full/main/en-QT/ca-gregorian.json"));
const qtCurrency = __importStar(require("./data/cldr-numbers-full/main/en-QT/currencies.json"));
const qtDateFields = __importStar(require("./data/cldr-dates-full/main/en-QT/dateFields.json"));
const qtNumbers = __importStar(require("./data/cldr-numbers-full/main/en-QT/numbers.json"));
const usCurrency = __importStar(require("./data/cldr-numbers-full/main/en/currencies.json"));
const usNumbers = __importStar(require("./data/cldr-numbers-full/main/en/numbers.json"));
const weekData = __importStar(require("./data/cldr-core/supplemental/weekData.json"));
const zaCalendar = __importStar(require("./data/cldr-dates-full/main/en-ZA/ca-gregorian.json"));
const zaCurrency = __importStar(require("./data/cldr-numbers-full/main/en-ZA/currencies.json"));
const zaDateFields = __importStar(require("./data/cldr-dates-full/main/en-ZA/dateFields.json"));
const zaNumbers = __importStar(require("./data/cldr-numbers-full/main/en-ZA/numbers.json"));
const { load } = KendoReactIntl;
exports.loadLocaleData = (locales) => {
    load(likelySubtags, currencyData, weekData);
    if (locales.indexOf("en-US") !== -1) {
        load(usCurrency, usNumbers);
    }
    if (locales.indexOf("es-MX") !== -1) {
        load(esCurrency, esNumbers, esCalendar, esDateFields);
    }
    if (locales.indexOf("fr-CA") !== -1) {
        load(frCalendar, frCurrency, frDateFields, frNumbers);
    }
    if (locales.indexOf("fr-FR") !== -1) {
        load(frCalendar, frCurrency, frDateFields, frNumbers);
    }
    if (locales.indexOf("en-GB") !== -1) {
        load(gbCalendar, gbCurrency, gbDateFields, gbNumbers);
    }
    if (locales.indexOf("en-ZA") !== -1) {
        load(zaCalendar, zaCurrency, zaDateFields, zaNumbers);
    }
    if (locales.indexOf("en-NZ") !== -1) {
        load(nzCalendar, nzCurrency, nzDateFields, nzNumbers);
    }
    if (locales.indexOf("en-AU") !== -1) {
        load(auCalendar, auCurrency, auDateFields, auNumbers);
    }
    if (locales.indexOf("en-QT") !== -1) {
        load(qtCalendar, qtCurrency, qtDateFields, qtNumbers);
    }
    if (locales.indexOf("ja-JP") !== -1) {
        load(jpCalendar, jpCurrency, jpDateFields, jpNumbers);
    }
};
exports.defaultLocaleId = "en-US";
exports.KendoIntl = { ...TelerikIntl, ...KendoReactIntl };
//# sourceMappingURL=locales.js.map